import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import ComposePost from "@/components/ComposePost";
import PostCard from "@/components/PostCard";
import StoriesBar from "@/components/StoriesBar";
import CalmAdSlot from "@/components/CalmAdSlot";
import DiscoveryWidget from "@/components/DiscoveryWidget";

export default function FeedPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const AD_DISMISS_KEY = "haeven_ad_dismissed_at";
  const AD_DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
  const [adDismissed, setAdDismissed] = useState(() => {
    const v = localStorage.getItem(AD_DISMISS_KEY);
    if (!v) return false;
    const at = Number(v);
    return Number.isFinite(at) && Date.now() - at < AD_DISMISS_TTL_MS;
  });
  const dismissAd = () => {
    localStorage.setItem(AD_DISMISS_KEY, String(Date.now()));
    setAdDismissed(true);
  };
  const { user } = useAuth();
  const isPremium = !!user?.premium?.active;
  const showAds = !isPremium && !adDismissed;

  const load = async () => {
    try { const r = await api.get("/posts/feed"); setPosts(r.data); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="feed-page">
      <div className="mb-6">
        <h1 className="text-4xl">Your HAEVEN</h1>
        <p className="text-muted-foreground mt-1">Hi {user?.display_name?.split(" ")[0]} — here&apos;s what your circles are sharing.</p>
      </div>

      <StoriesBar />
      <ComposePost onPosted={(p) => setPosts([p, ...posts])} />

      {loading ? (
        <div className="brutal-card p-6 bg-card">Loading feed…</div>
      ) : posts.length === 0 ? (
        <div className="space-y-5">
          <div className="brutal-card p-8 bg-sage text-center">
            <h3 className="text-2xl">Calm waters here</h3>
            <p className="mt-1 text-muted-foreground">Follow a few people, or be the first to share something kind today.</p>
          </div>
          <DiscoveryWidget />
        </div>
      ) : (
        <div className="space-y-5">
          {posts.map((p, i) => (
            <React.Fragment key={p.id}>
              <PostCard post={p} hideLikeCounts={user?.hide_like_counts} />
              {showAds && i === 2 && (
                <CalmAdSlot onDismiss={dismissAd} />
              )}
              {i === 4 && <DiscoveryWidget />}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}
